const HIGHLIGHT_CLASS = "user-manual-search-highlight";
const ACTIVE_CLASS = "is-active";

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/**
 * Walk text nodes only and wrap matches in <mark> elements.
 * Never mutates tag names, attributes, or non-text structure.
 */
export const applyTextHighlights = (container, query) => {
	if (!container || !query) {
		return [];
	}

	const regex = new RegExp(escapeRegExp(query), "gi");
	const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
		acceptNode(node) {
			if (!node.nodeValue) {
				return NodeFilter.FILTER_REJECT;
			}

			const parent = node.parentElement;
			if (!parent) {
				return NodeFilter.FILTER_REJECT;
			}

			if (parent.closest("script, style, noscript")) {
				return NodeFilter.FILTER_REJECT;
			}

			return NodeFilter.FILTER_ACCEPT;
		},
	});

	const textNodes = [];
	let current = walker.nextNode();
	while (current) {
		textNodes.push(current);
		current = walker.nextNode();
	}

	const marks = [];

	// Process from the end so earlier text-node references stay valid.
	for (let i = textNodes.length - 1; i >= 0; i -= 1) {
		const textNode = textNodes[i];
		const text = textNode.nodeValue;
		const segments = [];
		let lastIndex = 0;
		let match;

		regex.lastIndex = 0;
		while ((match = regex.exec(text)) !== null) {
			if (match.index > lastIndex) {
				segments.push({ type: "text", value: text.slice(lastIndex, match.index) });
			}
			segments.push({ type: "match", value: match[0] });
			lastIndex = match.index + match[0].length;

			// Avoid zero-length infinite loops for edge-case patterns.
			if (match[0].length === 0) {
				regex.lastIndex += 1;
			}
		}

		if (!segments.length) {
			continue;
		}

		if (lastIndex < text.length) {
			segments.push({ type: "text", value: text.slice(lastIndex) });
		}

		const fragment = document.createDocumentFragment();
		const nodeMarks = [];

		segments.forEach((segment) => {
			if (segment.type === "text") {
				if (segment.value) {
					fragment.appendChild(document.createTextNode(segment.value));
				}
				return;
			}

			const mark = document.createElement("mark");
			mark.className = HIGHLIGHT_CLASS;
			mark.textContent = segment.value;
			fragment.appendChild(mark);
			nodeMarks.push(mark);
		});

		textNode.parentNode.replaceChild(fragment, textNode);
		marks.unshift(...nodeMarks);
	}

	return marks;
};

export const setActiveHighlight = (marks, activeIndex) => {
	marks.forEach((mark, index) => {
		mark.classList.toggle(ACTIVE_CLASS, index === activeIndex);
	});
};

export const HIGHLIGHT_CLASS_NAME = HIGHLIGHT_CLASS;
